var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSlreact = function SvgSlreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M24 9H0V3.45Q0 3 .45 3h23.1q.45 0 .45.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M23.55 21H.45Q0 21 0 20.55V15h24v5.55q0 .45-.45.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M24 9H0v6h24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1641D5",
    d: "M5.85 16.5C4.5 15 3 13.5 3 12V7.5h6V12c0 1.5-2.85 4.35-3 4.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m7.5 11.25-.955.14h-.272V10.8l.272.03.682.14-.136-.422.136-.422-.682.14h-.272v-.28L6.75 9h-1.5l.477.984v.282h-.136l-.682-.141.136.422-.136.422.682-.14h.136v.562h-.272L4.5 11.25l.136.422-.136.422.955-.14h.272l-.136 1.85h.807l-.125-1.85h.272l.955.14-.136-.422z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M6 13.5c-.75 0-1.5.75-1.5 1.5 0 0 .214-.9 0-.9-.857 0-1.5.36-1.5.84 1.286.96 2.786 1.56 2.786 1.56h.428s1.5-.6 2.786-1.56c0-.48-.643-.84-1.5-.84 0 0 .214.9 0 .9 0-.75-.857-1.5-1.5-1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M9 7.5v4.2C9 13.5 6 15 6 15s-3-1.5-3-3.3V7.5zM10.5 6h-9v6c0 3.15 4.5 4.5 4.5 4.8 0-.3 4.5-1.65 4.5-4.8z"
  })));
};
export default SvgSlreact;